import styled from "styled-components";

export const StyledMain = styled.main`
	position: relative;
	padding-top: 30px;

	display: flex;
	flex-direction: column;
	justify-content: space-between;

	background: ${(p) => p.theme.colors.white};
	width: 1200px;
	min-height: 100vh;
	margin: 125px auto 30px auto;
	/* margin-bottom: 30px; */

	box-shadow: ${(p) => p.theme.shadow};
	border-radius: 10px;

	@media (max-width: 420px) {
		width: 94%;
	}
`;
